import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.autoResize()
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }

  submit(event) {
    if (!this.inputTarget.value.trim()) {
      event.preventDefault()
      return
    }
    // Clear input after form submits
    requestAnimationFrame(() => {
      this.inputTarget.value = ""
      this.autoResize()
    })
  }

  autoResize() {
    const input = this.inputTarget
    input.style.height = "auto"
    input.style.height = `${input.scrollHeight}px`
  }
}
